
<template>
  <div class="w-full" v-if="isCardActiveLocal">
    <div class="flex mb-2" style="justify-content: space-between;">
      <div class="flex" style="align-items: center;">
        <h4 style="margin-bottom: 0;">Select a Classroom</h4>
      </div>
      <vx-input-group class="input-group-with-input-for-filtering ml-4" style="">
        <template slot="prepend">
          <div class="prepend-text ">
            <span><feather-icon class="pt-1" icon="SearchIcon" svg-classes="stroke-current h-5 w-5"></feather-icon></span>
          </div>
        </template>

        <vs-input class="dashboard-filter-input" placeholder="Search here..." v-model="classroomFilterText"/>
      </vx-input-group>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full" style="padding-left: 0; padding-right: 0;">
        <div v-if="!loadingDataCards" class="vx-row data-card-container">
          <div class="vx-col mb-3" v-for="(classroom, index) in classrooms" :key="index" style="padding-left: 0; padding-right: 0;">
            <data-card :extraButtons="true" @handleStudentClick="selectedStudent(classroom)" @handleModuleClick="selectedModule(classroom)" :smallText="true" class="mx-2" type="classroom" @handleClick="selectedClassroom(classroom)" :title="classroom.classroom" :myTime="classroom.timeSpentMaxStudent" :avgTime="classroom.timeSpentAvgClassroom" :radialData="[classroom.scoreMaxStudent, classroom.scoreAvgClassroom]" :highestAvg="true"/>
          </div>          
        </div>
        <div v-if="loadingDataCards" class="vx-row data-card-container">
          <div class="vx-col w-full mb-3" style="padding-left: 0; padding-right: 0;">
            <data-card-skeleton :extraButtons="true" :count="4"/>
          </div>
        </div>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full">
        <line-chart :isLoading="loadingChartsTime" @filterDropdownChanged="filterDropdownChangedStudentGraphTimeSpent" :series="timeSpentSeries" :title="'Time Spent'" :filterList="listOfclassroomsForDropdown"/>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <line-chart :isLoading="loadingChartsScore"  @filterDropdownChanged="filterDropdownChangedStudentGraphScore" :series="scoreSeries" :title="'Score'" :filterList="listOfclassroomsForDropdown"/>
      </div>
    </div>
  </div>
</template>


<script>
import vSelect from 'vue-select'
import DataCard from './DataCard.vue'
import UserDetails from './UserDetails.vue'
import CustomSkeleton from './CustomSkeleton.vue'
import DataCardSkeleton from './DataCardSkeleton.vue'
import LineChart from './LineChart.vue';
export default {
  name: "classroom",
  components: {
    vSelect,
    DataCard,
    UserDetails,
    CustomSkeleton,
    DataCardSkeleton,
    LineChart
  },
  props: {
    isCardActive: {
      type: Boolean,
      required: true
    },
    userDetails:{
      type:Object,
      required: true
    }
  },
  data() {
    return {
      loadingDetails:true,
      loadingDataCards:true,
      loadingChartsTime:true,
      loadingChartsScore:true,
      classrooms: [],
      originalclassrooms: [],
      classroomFilterText: "",
      listOfclassroomsForDropdown: [],
      scoreSeries:[],
      timeSpentSeries:[],
      userDetailsObject:{},
    };
  },
  watch: {
    isCardActive: function(val) {
      var self = this;
      if(val){
        self.getclassrooms();
        localStorage.setItem("Teacher_Position",JSON.stringify(self.userDetails));
        localStorage.setItem("Active_Card","2");
      }
      if(!val){
        self.timeSpentSeries = [];
        self.scoreSeries = [];
      }
    },
    classroomFilterText: function(val) {
      var self = this;
      if(val) {
        self.classrooms = self.originalclassrooms.filter(function(x) { return x.name.toLowerCase().includes(val.toLowerCase()) });
      } else {
        self.classrooms = self.originalclassrooms;
      }
    }
  },
  computed: {
    isCardActiveLocal: {
      get() {
        return this.isCardActive;
      },
      set(val) { }
    },
  },
  methods: {
    getclassrooms() {
      var self = this;

      self.loadingDetails = true;
      self.loadingDataCards = true;

      var onSuccess = function(response) {
        self.classrooms = response.data;
        self.listOfclassroomsForDropdown = self.classrooms.map((item) => {return { label: item.classroom, value: item.classroomId }});

        self.originalclassrooms = self.classrooms;
      };

      var onFinally = function() {
        self.loadingDataCards = false;
        self.loadingChartsTime = false;
        self.loadingChartsScore = false;
      };
      self.$ajaxGet(self, `PrincipalDashboard/GetClassroomList?selectedGradeId=${self.userDetails.selectedGrade.gradeId}&selectedSubjectId=${self.userDetails.selectedGradeSubject.subjectId}`, onSuccess, onFinally);
    },
    selectedclassroom(classroom){
      this.$emit('selectedclassroom', classroom);
      this.userDetails.selectedclassroom = classroom;
    },
    filterDropdownChangedStudentGraphTimeSpent(classroomName,classroomId,selectedDate) {
      var self = this;
      this.loadingChartsTime = true;
      var onSuccess = response =>{
        self.timeSpentSeries = [
          {
            name: "Single Student Avg.",
            data: response.data.avaragesList,
          },
          {
            name: "Combined Student Avg.",
            data: response.data.timeSpentAvaragesList
          }
        ];
      }
      var onFinally = response =>{
        self.loadingChartsTime = false;
      }
    
      self.$ajaxGet(self, `PrincipalDashboard/TimeSpentGraphHighest?month=${selectedDate.monthIndex}&year=${selectedDate.year}&gradeId=${this.userDetails.selectedGrade.gradeId}&courseId=${this.userDetails.selectedGradeSubject.subjectId}&classroomId=${classroomId}` , onSuccess, onFinally);
    },
    filterDropdownChangedStudentGraphScore(classroomName,classroomId,selectedDate) {
      var self = this;
      this.loadingChartsScore = true
      var onSuccess = response =>{
        self.scoreSeries = [
          {
            name: "Single Student Avg.",
            data: response.data.scoreList,
          },
          {
            name: "Combined Student Avg.",
            data: response.data.scoreListAvg,
          },
        ];
      }
    
      var onFinally = response =>{
        self.loadingChartsScore = false;
      }
      self.$ajaxGet(self, `PrincipalDashboard/HigestScore?month=${selectedDate.monthIndex}&year=${selectedDate.year}&gradeId=${this.userDetails.selectedGrade.gradeId}&courseId=${this.userDetails.selectedGradeSubject.subjectId}&classroomId=${classroomId}` , onSuccess, onFinally);
    },
    selectedStudent(classroom){
      this.$emit('selectedClassroomStudentList',classroom)
    },
    selectedModule(classroom){
      this.$emit('selectedClassroomModule',classroom)
    }
  },
  created() {
  },
  mounted() {
  }
};
</script>